/**
 * 科创号
 */

import Container from '@/containers';

const snsRouter = {
    path: '/sns',
    component: Container,
    redirect: '/sns/kechuanghao',
    name: 'SNS',
    meta: {
        title: '科创号'
    },
    children: [
        {
            path: 'kechuanghao',
            component: () => import('@/views/sns/keChuangHao'),
            name: 'KeChuangHao',
            meta: {
                title: '科创号',
                showAddBtn:true
            }
        },
        {
            path: 'kechuanghaolist',
            component: () => import('@/views/sns/keChuangHaoList'),
            name: 'keChuangHaoList',
            meta: {
                title: '科创号列表',
                showAddBtn:true
            }
        },
        {
            path: 'index',
            component: () => import('@/views/sns/keChuangHaoIndex'),
            name: 'keChuangHaoIndex',
            meta: {
                title: '科创号主页',
                showAddBtn:true
            }
        },
        {
            path: 'list',
            component: () => import('@/views/sns/list'),
            name: 'SNSList',
            meta: {
                title: '科创圈',
                showAddBtn:true
            }
        },
        {
            path: 'detail',
            component: () => import('@/views/sns/detail'),
            name: 'DynamicDetail',
            meta: {
                title: '动态详情',
                showAddBtn:true
            }
        },
        {
            path: 'forward',
                component: () => import('@/views/sns/forward'),
            name: 'forward',
            meta: {
                title: '转发'
            }
        },
        {
            path: 'authentication',
            component: () => import('@/views/sns/authentication'),
            name: 'Authentication',
            meta: {
                title: '认证科创号'
            }
        },
        {
            path: 'commentlist',
            component: () => import('@/views/sns/commentList'),
            name: 'CommentList',
            meta: {
                title: '评论列表'
            }
        }
    ]
};

export default snsRouter;
